import React from 'react';
import { Avatar, AvatarSize } from '../../../DesignSystem/VendorProfile/Avatar';
import { VendorInfo } from './VendorInfo';
import Button from '../../../generic-components/Button';
import { ReactComponent as DropDownIcon } from '../../../assets/vendor-manager/vendor-chevron.svg';
import { STYLES } from '../consts';

interface IProps {
    onClick: () => void;
    name: string;
    email?: string
    vendorId: string;
}
export const VendorPresentor = ({
  onClick, name, email, vendorId,
}: IProps) => (
  <Button
    onClick={onClick}
    className={STYLES.VENDOR_PRESENTOR.WRAPPER}
    childElement={(
      <div className={STYLES.VENDOR_PRESENTOR.CHILDREN_WRAPPER}>
        <Avatar id={vendorId} name={name} size={AvatarSize.LARGE} />
        <VendorInfo name={name} email={email} />
        <DropDownIcon className={STYLES.VENDOR_PRESENTOR.ICON} />
      </div>
        )}
    id='vendorPresentor'
  />
);
